export const NEONSPORTZ_IMPORT_ERROR_MESSAGES: Record<string, string> = {
  invalid_neonsportz_url: 'Enter a valid NeonSportz league URL (e.g. https://neonsportz.com/leagues/LTL).',
  unsupported_host: 'Only neonsportz.com league URLs are supported.',
  neonsportz_league_not_imported:
    'This NeonSportz league is not imported yet. Import/sync the league in NeonSportz first, then try again.',
  neonsportz_fetch_timeout: 'NeonSportz took too long to respond. Try again or upload CSV instead.',
  neonsportz_provider_unavailable:
    'NeonSportz is unavailable right now. Try again later or upload CSV instead.',
  neonsportz_empty_teams: 'NeonSportz returned no teams for this league.',
  neonsportz_empty_games: 'NeonSportz returned no games for this league.',
  neonsportz_too_many_games: 'This league has more games than preview can safely load.',
  neonsportz_apply_failed: 'Import saved the snapshot but could not apply matches. Try again from Import.',
  neonsportz_import_failed: 'NeonSportz import failed. Please try again.',
  season_label_required:
    'Choose a season in Refresh from NeonSportz -> Season label, then click Preview league.',
};

export function formatNeonsportzImportError(
  message: string,
  errorCode?: string
): string {
  if (errorCode && NEONSPORTZ_IMPORT_ERROR_MESSAGES[errorCode]) {
    return NEONSPORTZ_IMPORT_ERROR_MESSAGES[errorCode];
  }
  return message;
}

export function formatDiscordMemberLabel(
  discordUsername?: string | null,
  discordId?: string | null
): string {
  if (discordUsername) return discordUsername;
  if (discordId) return `Discord ID ${discordId}`;
  return '—';
}

export function formatDiscordIdStatus(status?: string): string {
  if (status === 'present') return 'Present';
  return 'Missing';
}

export function formatTwitchLogin(value?: string | null): string {
  return value || 'Missing';
}
